import i18n from "@/i18n";

i18n.mergeLocaleMessage("en", {
  login: {
    full_name: "YOUR FULL USERNAME",
    user: "your user",
    password: "password",
    forgot_password: "Forgot your password?",
    remember_user: "Remember my user",
    integration_login: "Please, close the window and open it again.",
    error: {
      invalid_credentials: "Invalid credentials. Try again, please.",
      rate_limit: "Too many login attempts. Try again in {retry}.",
      retry_soon: "a moment",
      retry_seconds: "{count} second | {count} seconds",
      retry_minutes: "{count} minute | {count} minutes"
    },
    footer: {
      "help-label": "Help",
      "faq-label": "FAQ"
    }
  },
  user: {
    "my-account": "My account",
    "user-form": {
      username: "System User",
      name: "User name",
      email: "E-mail",
      "company-name": "Company Name",
      "company-doc": "Company Doc",
      "company-phone": "Phone Number",
      "company-address": "Full address",
      "company-zipcode": "Zip Code",
      "company-title": "Company",
      "api-integration": "API Integration",
      "company-client-id": "Access Key",
      "company-client-secret": "Access Secret Key",
      "my-data": "My data",
      "generate-secret": "Generate Secret",
      "confirmation-secret-key": "Generate Access Secret Key",
      "confirmation-body":
        "Do you really want to generate a new secret key? This will wipe out the current one."
    },
    "secret-key-modal": {
      title: "Access Secret Key",
      label: "Secret",
      "show-secret": "Show",
      "hide-secret": "Hide",
      "copy-label": "Copy to Clipboard",
      copy: "Copy",
      copied: "Copied",
      "disclaimer-1": "The secret key will be visible once.",
      "disclaimer-2": "Please store it with caution!",
      "disclaimer-3":
        "If you lose the secret key it will be necessary to generate a new one.",
      close: "Close"
    },
    "btn-header-label": "Change Password"
  },
  sidebar: {
    owners: "Owners",
    "farms-home": "Farms",
    analysis: "Analysis",
    "add-owner": "Add Owner",
    toolbox: "Toolbox",
    logout: "Logout",
    collapse: "Collapse",
    expand: "Expand",
    profile: "My Profile",
    analitica: "Analítica",
    sentinela: "Sentinela",
    ruraluno: "rural.uno",
  },
  confirmation: {
    "title-default": "Warning",
    "body-text-default": "",
    "button-primary-label": "Confirm",
    "button-secondary-label": "Cancel"
  },
  farms: {
    "owner-form": {
      title: "Register owner's data",
      "document-label": "Document",
      'owner-key-label': 'identifier',
      'owner-key-placeholder': 'identifier e.g. north_region, soybean_2022, silva',
      "owner-label": "owner",
      "tel-label": "PHONE",
      "phone-label": "CELLPHONE",
      "email-label": "e-mail",
      "admitted-label": "ADMITTED",
      "city-label": "CITY",
      "state-label": "STATE",
      "edit-label": "Edit",
      "save-label": "SAVE INFORMATIONS",
      "saving-informations-label": "Saving...",
      "saved-informations-label": "Informations Saved",
      "tel-error-message": "Please, insert a valid phone number",
      "phone-error-message": "Please, insert a valid cell phone number",
      "phone-number-input": {
        "country-selector-label": "Country code",
        "country-selector-error": "Select a country",
        example: "Example: "
      }
    },
    "farm-item": {
      "farm-name": "Farm Name",
      "territory-code": "Territory Code",
      "farm-area": "Area",
      "farm-location": "Location",
      "btn-edit": "Edit",
      "btn-add-analysis": "Add Analysis",
      "btn-add-monitoring": "Add Monitoring",
      "btn-remove": "Remove",
      "analitica-denied": "To get access to analitica, contact our sales team",
      "sentinela-denied": "To get access to sentinela, contact our sales team"
    },
    "farm-form": {
      "owner-name": "Owner Name",
      "owner-document": "Document",
      "farm-location": "Location",
      "farm-area": "Area",
      "farm-name": "Farm Name"
    },
    "farm-analysis-form": {
      "owner-name": "Owner Name",
      "farm-name": "Farm Name",
      culture: "Culture",
      period: "Period",
      "crop-type": "Crop Type",
      SOY: "SOY",
      CORN: "WINTER CORN",
      SUGARCANE: "SUGARCANE",
      "monitoring-year": "Monitoring Year",
      "select-monitoring-year": "Select monitoring year"
    },
    "farm-draw-confirm": {
      title: "Ownership Verification",
      "btn-save-label": "Save",
      "btn-next-label": "Next",
      "btn-edit-label": "Edit"
    },
    "farm-analysis-confirm": {
      ANALITICA: "Analysis Confirmation",
      SENTINELA: "Monitoring Confirmation",
      "btn-save-label": "Process",
      "btn-cancel-label": "Cancel"
    },
    "owner-select": {
      title: "Confirm Owner",
      label: "Owner: (Optional)",
      "no-owner": "No owner",
      "no-owners": "Sorry, no owner found",
      "loading-more-options": "Loading more owners...",
      "btn-save-label": "Save",
      "btn-edit-label": "Back",
    },
    "farm-owner": "Farms of",
    "farm-total-area": "Total area",
    "no-farm-owner": "Farms of Owner",
    "btn-back": "Back",
    "add-farm": "Add Farm",
    "search-farm": "Search Farm",
    "search-placeholder": "Search by farm, city or state",
    "farm-controller": {
      "confirmation-label":
        'Do you confirm the creation of the farm <strong style="color: inherit; font-weight: bolder;">{farmName}</strong> for <strong style="color: inherit; font-weight: bolder;">{ownerName}</strong>?',
      "confirmation-without-owner-label":
        'Do you confirm the creation of the farm <strong style="color: inherit; font-weight: bolder;">{farmName}</strong>?',
      "cancel-label": "Cancel",
      "confirm-label": "Confirm",
      "geometry-textarea": "Geometry GeoJSON "
    },
    "analysis-item": {
      "created-at-label": "Created at",
      "crop-type-label": "Crop Type",
      "period-label": "Period",
      ANALITICA: "Analysis",
      SENTINELA: "Monitoring",
      "crop-types": {
        SOY: "Soy",
        CORN: "Corn"
      },
      "analysis-status": "status",
      "analysis-active": "Active Monitoring",
      "analysis-disabled": "Inactive Monitoring"
    },

    "farm-delete-confirmation-title": "Farm exclusion",
    "farm-delete-confirmation": "Do you want to remove the farm: {farm} ?",
    "analysis-delete": {
      button: "DELETE",
      title: "Delete Analysis",
      text: "The processing realized by this analysis will be charged!"
    },
    "car-search": {
      title: "Search by CAR",
      "input-label": "Enter the farm CAR",
      "label": "CAR",
      "btn-save-label": "Search",
      "btn-cancel-label": "Cancel"
    },
    "car-select": {
      "modal-title": "Select the CAR",
      "rural-code": "Car Code:",
      area: "Farm Area:",
      "tipo-imovel": "Property Type:",
      "btn-close-label": "Cancel",
      "warn-bloqued-farm": "The selection of this farm is temporarily blocked because it has more than 15 thousand hectares, please contact the administrators.",
    }
  },
  core: {
    "input-cpf": {
      "invalid-cpf": "Please, insert a valid CPF."
    },
    "state-selector-controller": {
      placeholder: "STATE",
      "loading-placeholder": "Loading..."
    },
    "city-selector-controller": {
      placeholder: "CITY",
      "loading-placeholder": "Loading..."
    },
    "wrapped-gm": {
      "draw-polygon": "draw polygon",
      "paste-polygon": "Paste polygon",
      car: "Insert By Car",
      "clear-drawing": "clear drawing",
      "zoom-in": "zoom in",
      "zoom-out": "zoom out",
      "search-placeholder": "Enter a location",
      language: "en",
      region: "US",
      latLngLabel: "lat: {lat} | lng: {lng}",
      "download-geojson": "Download as GeoJSON",
      "hide-label": "Hide Labels",
      "show-label": "Show Labels",
      'car-near': 'Get near CAR\'s',
      'remove-car-near': 'Remove near CAR\'s',
      'layer-order': 'Polygon on top'
    }
  },
  notifications: {
    success: {
      title: "Success!",
      farmMessage: "Farm {farmName} created with success",
      analysisMessage: "Analysis created with success",
      "owner-admitted-message": "Owner admitted with success {name}",
      "owner-unadmitted-message": "Owner unadmitted with success {name}",
      "reset-password": "Please check your registered email!",
      "delete-farm": "Farm removed!",
      "owner-delete": "Owner deleted with success {name}!",
      "analysis-delete": "Analysis delete with success!",
      "map-file-upload-success": "Map file sended with success!",
      "analysis-update": "Analysis successfully updated",
    },
    warning: {
      title: "Attention!"
    },
    error: {
      title: "Error!",
      message: "Was an error on the server, please try again.",
      "owner-admitted-message": "Error while admitting owner {name}",
      "owner-unadmitted-message": "Error while unadmitting owner {name}",
      "user-change-password-message":
        "Error changing password, please enter the information and try again.",
      "user-change-password-incorrect-message":
        "Error, your old password is incorrect!!",
      "user-save-password":
        "Error, token has expired or is invalid, please request password change again",
      "delete-farm": "Error when removing farm!",
      "owner-delete": "Error while deleting owner {name}",
      "analysis-delete": "Error while deleting analysis!",
      "trial-farm-limit-exceeded":
        "Has not possible to create a Farm, because as exceeded the quota of {farmsCount} farms. To increase the limit or do a upgrade from your account, contact the system administrator!",
      "trial-analysis-limit-exceeded":
        "Has not possible to create a Analysis, because as exceeded the quota of {analysisCount} analysis. To increase the limit or do a upgrade from your account, contact the system administrator!",
      "product-not-allowed":
        "Contact our sales team to get acceess to this product",
      "map-file-upload-error": "Error with send file!",
      "map-file-without-features": "The uploaded file has no polygon!",
      "generate-secret-key-error":
        "Could not generate a new secret key: the company doesn't exists",
      "generate-secret-key-other-error":
        "Could not generate a new secret key, please try again",
      "search-by-car-empty":
        "No farms with the informed CAR code were found, please try again",
      "search-by-car-error": "Error fetching farms!",
      "search-by-lat-lng-empty": "We couldn't find CAR for the selected location",
      "search-by-lat-lng-error": "We couldn't retrieve the CARs in the point, please try again",
      "invalid-geometry-intersection": "Invalid geometry: the geometry is intersecting itself.",
      "bulk-csv-file-converter-parse": "Error while converting file data.",
    }
  },
  analysis: {
    "analysis-not-started": "Please wait...",
    "go-back": "Go Back",
    "go-to-compare": "View comparison",
    "farm-owner": "Property of {ownerName}",
    "no-farm-owner": "None owner",
    "farm-name": "Farm:",
    "processing-message":
      "This analysis still in process. Wait for a moment...",
    "finished-with-success": "Finished with success",
    "finished-with-error":
      "The process was finished with error. You wotn't be charged for this process.",
    "loading-results": "Loading results...",
    tabs: {
      summary: "Summary",
      weather: "Weather",
      environmental: "Environmental (CAR)",
    },
    summary: {
      "farm-area": "Total area",
      "arable-area": "Areable area",
      "crop-area": "{crop_type} area",
      yield: "Yield",
      production: "Production",
      "average-planting-date": "Average planting",
      "average-harvest-date": "Average harvest",
      city: "City",
      state: "State",
      "micro-region": "Micro Region",
      "yield-std": "Yield STD",
      "score-std": "Score STD",
      "crop-area-too-small":
        "The system didn`t find any significant area {crop_type} in this farm.",
      "culture-type": "Crop type:",
      'yield-scores': 'Yield Scores in crop year:',
    },
    "ndvi-chart": {
      "farm-label": "Farm - {crop_type}",
      "farm-label-not-confirmed": "Farm - not confirmed"
    },
    step: {
      VISTA: "Finding dates",
      CROP_SEG: "Segmenting plots",
      YIELDEST: 'Calculating yield',
      GET_VI: "Looking for vegetation indexes",
      PLOT_DOCTOR: "Finding crops",
      YIELD_SCORE: "Generating score",
      SUMMARY: "Generating results file"
    },
    status: {
      PROCESSING: "Processing",
      FINISHED: "Finished",
      ERROR: "Error"
    }
  },
  "analysis-delete": {
    button: "DELETE",
    title: "Delete Analysis",
    text: "The processing realized by this analysis will be charged!"
  },
  toolbox: {
    culture: "Culture",
    owner: "Owner",
    year: "Year",
    monitoringSheet: "Sentinela - Monitoring Sheet",
    cpfToCar: "CPF/CNPJ to CAR - Sheet",
    cpfToEg: "CPF/CNPJ to Economic Group - Sheet",
    riskReport: "Analitica Risk - Sheet",
    download: "Download",
    consult: "Consult",
    clearQuery: "Clear query"
  },
  sentinela: {
    search: "Search",
    harvest: "Harvest",
    cropType: "Culture",
    clear: "Clear filters",
    farmName: "Farm",
    ownerName: "Farm Owner",
    farmArea: "Farm Area",
    cropArea: "Crop Area",
    harvestPercentage: "% Harvest",
    monitoringYear: "Crop Year",
    "view-monitoring": "View monitoring"
  },
  owners: {
    name: "Name",
    cpf: "Doc",
    ownerKey: "Identifier",
    email: "E-mail",
    phone: "Phone",
    "cell-phone": "Cell Phone",
    state: "State",
    city: "City",
    country: "Country",
    "my-owners": "My Owners",
    "all-owners": "All owners",
    "every-owner": "Every owner",
    "no-result": "No owner to display...",
    "filter-owner": "Filter owners",
    admitted: "Admitted",
    admit: "Admit",
    unadmit: "Unadmit",
    "not-admitted": "Not Admitted",
    all: "All",
    "farms-count": "Farms",
    "farm-area": "Total Area",
    options: "Options",
    filters: "Filters",
    "filters-apply": "Close",
    "no-info": "No information",
    "filter-clear": "Clear Filter",
    "add-owner": "Add Owner",
    "btn-back": "Back",
    "owner-table": {
      admitted: "Admitted",
      name: "Name",
      ownerKey: "Identifier",
      farmCount: "Farms",
      farmArea: "Farm Area",
      city: "City",
      state: "State",
      actions: "Actions"
    },
    owners: "Owners"
  },
  "crop-types": {
    SOY: "Soybean",
    CORN: "Corn",
    WINTER_CORN: "Corn",
    SUGARCANE: "Sugacane",
    PASTURE: "Any",
    ANY: "Undefined",
    UNKNOWN: "Undefined",
    FOREST: "Forest formation",
    RICE: "Rice",
    COFFEE: "Coffee",
    CITRUS: "Citrus",
    COTTON: "Cotton",
    EUCALYPTUS: "Forest Plantation",
    NO_CROP: "Undefined",
    null: "Undefined"
  },
  "harvest-season": {
    SUMMER: "Main",
    WINTER: "Winter"
  },
  "harvest-season-unified": {
    SUMMER: "First Crop",
    WINTER: "Second Crop"
  },
  "harvest-data-editor": {
    button: "Edit field data",
    title: "Edit field data",
    "col-label": "Field",
    "col-crop-type": "Crop",
    "col-yield": "Yield (sc/ha)",
    "col-seeding": "Seeding",
    "col-harvest": "Harvest",
    save: "Save",
    cancel: "Cancel",
    success: "Data saved. Scores are being recalculated...",
    "no-changes": "No changes to save.",
    "error-409": "The analysis is being processed. Please try again shortly.",
    "error-404": "Field or analysis not found.",
    "error-403": "You don't have permission for this action.",
    "error-generic": "Could not save the changes."
  },
  "crop-table": {
    label: "Label",
    yield: "Yield",
    area: "Area",
    score: "Score",
    culture: "Culture",
    "city-score": "City",
    "microregion-score": "Mic.",
    "state-score": "Sta.",
    "country-score": "Cou.",
    seeding: "Seeding",
    harvest: "Harvest",
    production: "Production",
    status: "Status",
    processing: "Processing",
    finished: "Finished with success",
    error: "Finished with error",
    "yield-csv": "Yield(scs/ha)",
    "area-csv": "Area(ha)",
    "production-csv": "Production(scs)",
    "table-download": "Download Table Data",
    'sentinela-prime': 'Sentinela Prime',
  },
  "analysis-status": {
    PROCESSING: "Processing",
    FINISHED: "Finished",
    ERROR: "Error processing"
  },
  "logout-confirmation": {
    header: "Are you sure you want to logout?",
    body: " Don't worry, you won't lose any data or started process.",
    logout: "Logout",
    "go-back": "Go back"
  },
  "geojson-validation": {
    "only-polygon": "Accepts only type Polygon!",
    "invalid-geometry": "Geometry Invalid!",
    "only-one-polygon": "Only one Polygon is allowed!"
  },
  "change-password": {
    "alt-logo": "Logo agronow",
    "title-page": "Change password",
    "password-label": "New Password",
    "btn-label": "Confirm",
    "btn-login-label": "Go to login"
  },
  "user-change-password": {
    "title-page": "Change password",
    "password-label": "Current password",
    "new-password-label": "New password",
    "confirm-new-password-label": "Confirm new password",
    "btn-label": "Save",
    "btn-back": "Go Back",
    errors: {
      "min-length": "The password must contain 8 or more characters.",
      "password-match":
        "The new password and password confirmation must be identical"
    }
  },
  "reset-password": {
    "title-page": "Reset password",
    "user-info-label": "User Info",
    "user-info-placeholder": "Enter with e-mail or password",
    "confirm-label": "Confirm",
    "cancel-label": "Cancel",
    confirmation: "Ready!",
    "confirmation-email": "Check your email",
    "confirmation-ok": "Ok!"
  },
  charts: {
    owners: "Owners",
    area: "Area Histogram",
    "area-title": "Area Average {crop_type} / Producer",
    score: "Score Histogram",
    "area-expansion": {
      title: "Expansion/Retraction Area",
      "arable-area": "Arable",
      "crop-area": "Crop",
      "total-area": "Total"
    },
    "score-area-comparative": {
      "title-city": "City - Area percentage by yield score",
      "title-micro-region": "Micro Region - Area percentage by yield score",
      "title-state": "State - Area percentage by yield score",
      "title-country": "Country - Area percentage by yield score",
      "label": "{area} of the {cropType} area in {year} has yield score between {low} and {high}",
    },
    "comparative-score": {
      title: "Score by area",
      "score-city": "Score City",
      "score-country": "Score Country",
      "score-micro-region": "Score M. Region",
      "score-state": "Score State"
    },
    "yield-by-year": {
      title: "Yield/Year",
      "yield-in": "Yield in",
      yield: "Yield",
    },
    temperature: {
      name: "Temperature",
      current: "Current Year",
      historical: "Historical Average"
    },
    spi4: {
      name: "SPI Chart (Standardized Precipitation Index) x Meses",
      current: "Current Year",
      historical: "Historical Average"
    },
    months: {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    },
    "temperature-chart": {
      "empty-data": "Weather info not yet available."
    },
    "pace": {
      "crop-type-title": "Planting and harvesting progress - confirmed crop",
      "annual-title": "Planting and harvesting progress - eligible crop",
      "observablePlanted": "Observed date × planted area",
      "avgPlantingPlanted": "Average planting date × planted area",
      "avgHarvestHarvested": "Average harvest date × harvested area",
      "date": "Date",
      "area": "Area (ha)",
      "targetArea": "Target Area"
    },
  },
  "owners-delete": {
    "title-page": "Delete Owner",
    "owner-name": "Name: {name}",
    information: "All analysis generated by this owner will be charged!",
    "confirm-label": "Confirm",
    "cancel-label": "Cancel"
  },
  filter: {
    "title-page": "Filter",
    "confirm-label": "Confirm",
    "cancel-label": "Cancel",
    "score-chart": {
      culture: "Culture",
      "analysis-year": "Analysis Year",
      "analysis-year-none": "All Years",
      "harvest-season": "Harvest Season",
      "only-user-owners": "Only My Owners"
    },
    "score-area-comparative": {
      "yield-score-type": "Score Type"
    }
  },
  "yield-score": {
    YIELD_SCORE_CITY: "City",
    YIELD_SCORE_MICRO_REGION: "Region",
    YIELD_SCORE_STATE: "State",
    YIELD_SCORE_COUNTRY: "Country"
  },
  "compare-farms-owners": {
    "loading": "Loading comparison...",
    "load-error": "Could not load the comparison. Please try again.",
    "analysis-year": "Year",
    "average-planting-date": "Planting date",
    "average-harvest-date": "Harvest date",
    "average-yield": "Average yield",
    production: "Production",
    cycle: "Cycle",
    "compare": "Compare",
  },
  monitoring: {
    "monitoring-not-started": "Please wait...",
    "cutNumber": "\n Cut no. {cutCaneDate}",
    "pace": {
      "annual": "Eligible area",
      "crop-type": "Confirmed area",
    },
    summary: {
      "average-planting-date": "Average planting date",
      "average-planting-date-last-year":
        "Average planting date of the last year",
      "average-harvest-date": "Harvest date",
      "average-harvest-last-year": "Average harvest date of the last year",
      "average-yield": "Yield",
      area: "Area",
      "arable-area": "Arable area",
      "crop-area": "{crop_type} area",
      "harvest-area-analysis": "Culture area under analysis",
      "expansion-harvest-area": "Variation of the area under analysis"
    },
    "stage-steps": {
      PLANTED: "Planted",
      DEVELOPMENT: "Development",
      MATURATION: "Maturation",
      GERMINATION: "Cut",
      DRYING: "Drying",
      HARVESTED: "Harvested"
    },
    "stage-steps-letter": {
      PLANTED: "P",
      DEVELOPMENT: "D",
      MATURATION: "M",
      GERMINATION: "C",
      DRYING: "Y",
      HARVESTED: "H"
    },
    "evolution-chart": {
      "chart-label": "Yield",
      "last-year-label": "Last Year Yield"
    },
    select: "",
    cropLabel: "Label",
    area: "Area",
    yield: "Yield",
    "seeding-date": "Seeding",
    "estimated-harvest-date": "Harvest",
    cropStages: "Stage",
    cropType: "Crop Type",
    "info": "Info",
    "crop-type-undefined": "Undefined",
    "crop-type-nothing": "Nothing",
    "estimated-harvest-date": {
      label: "Estimated Harvest Date",
      undefined: "Undefined"
    },
    "time-line-subtitle": {
      SOY: "Soy",
      "NOT-SOY": "Not Soy",
      CORN: "Winter Corn",
      "NOT-CORN": "Not Winter Corn",
      undefined: "Unknown",
      SUGARCANE: "Sugarcane",
      "NOT-SUGARCANE": "Unknown",
    },
    "last-modified": "Last Modified: ",
    "last-image": "Last Image: ",
    "last-image-title": "Farm area covered by the image: {percentage}",
    "still-monitoring-label": "MONITORING",
    "still-monitoring-title": "This farm is being monitored.",
    "finished-monitoring-label": "FINISHED",
    "finished-monitoring-title": "The monitoring is already finished",
    "waiting-processing": "Waiting for processing...",
    tabs: {
      evolution: "Evolution",
      weather: "Weather (Beta)",
      environmental: "Environmental",
      crops: "Crops"
    },
    'last-image-info': {
      'sentinela-standard-title': 'Sentinela Standard',
      'sentinela-prime-title': 'Sentinela Prime',
      'last-image-label': 'Last Image:',
      'visible-percentage-label': 'Visible Percentage:',
      'sentinela-standard-description': 'Standard monitoring with open data. New satellite data every 5 days in the best case scenario.',
      'sentinela-prime-description': 'Monitoring with high resolution private data. New satellite data every 1 day in the best case scenario.',
    },
    'finish-warning': {
      'title': 'Do you want to finish the monitoring manually?',
      'text': 'You have an admin permission and can finish the monitoring manually. After finished it won\'t be update. This action cannot be reverted by you.',
      'confirm': 'Yes',
      'error-message': 'Try again later, please! Error: {message}',
    },
    'update':{
      'title': 'Run monitoring update',
      'text': 'Do you want to run the daily update routine?',
      'confirm': 'Yes',
      'success': 'Monitoring successfully updated',
    },
    'sette-maps': {
      'open': 'View in Sette Maps',
      'title': 'Sette Maps',
      'loading': 'Opening the map…',
      'authorizing': 'Authorizing the map…',
      'unreachable': 'The map did not respond. Try again in a moment.',
      'error': 'Could not open the map',
    },
    'crop-reset': {
      'title': 'Reset crop',
      'text': 'Do you want do recalculate all data for this crop?',
      'confirm': 'Yes',
      'success': 'Crop successfully reseted'
    }
  },
  "map-upload": {
    send: "Send",
    cancel: "Close",
    "drop-files": "Click or drag and drop files here",
    file: "File:"
  },
  "farms-home": {
    'title': 'Farms',
    'farm-name': 'Farm',
    'territory-code': 'Territory Code',
    'owner-name': 'Owner',
    'lng-lat-title': 'Lng/Lat',
    'lng-lat-placeholder': 'Lng/Lat Ex: -54.4332, -45.4422',
    'area': 'Area',
    'state-acronym': 'State',
    'city-name': 'City',
    'monitoring': 'Monitoring',
    'analyses': 'Analyses',
    'actions': 'Actions',
    'create-farm': 'Add Farm',
    'delete-farm': 'Remove Farm',
    'farm-area': 'Farm area',
    'farm-min-area': 'Minimum',
    'farm-max-area': 'Maximum',
    'only-user-farms': "My Farms",
    'only-active-monitoring': "Only Active Monitoring",
    'clear-filter': 'Clear Filters',
    "farm-delete-confirmation-title": "Remove Farm",
    "farm-delete-confirmation": "Do you want to remove the farm {farm} ?",
    "monitoring-year": "Year Monitored: {year}",
    "analyses-years": "Years Analysed: {years}",
    "analyses-list": {
      analitica: "Analyses",
      sentinela: "Monitorings",
      "no-analysis": "No analysis to display...",
    },
    "agro-cards": {
      analyses: "Analyses",
      areas: "Registered Area",
      "areas-unit": "ha",
      "areas-unit-larger": "k/ha",
      farms: "Farms",
      monitoring: "Monitoring",
      processing: "Processing",
    },
    "table-analyses-status": {
      "farm": "Farms",
      "ownerName": "Owner",
      "cropType": "Crop Type",
      "analysisType": "Type",
      "stepMessage": "Status",
    },
    "status-modal": {
      title: "Processing",
      farm: "Farm",
      owner: "Owner",
      status: "Status",
      "crop-type": "Crop Type",
      "crop-types": {
        SOY: "Soy",
        CORN: "Corn",
        SUGARCANE: "Sugacane",
        ANY: "Crop Types"
      },
    },

    "farm-upload-modal": {
      title: "Batch Registration - CSV File",
      'farm-name': 'Farm Name',
      'owner-name': 'Owner Name',
      'owner-id': 'Owner Id',
      'farm-shape-label': 'Farm Shape',
      'farm-shape-point': 'Point',
      'farm-shape-car': 'CAR Code',
      'farm-shape-sigef': 'INCRA Allotment Code',
      'farm-shape-geom': 'Geometry (geojson polygon)',
      'crop-type': 'Crop Type',
      'soy': 'Soy',
      'corn': 'Corn',
      'product': 'Product',
      'product-analitica': 'Analysis 4 last harvests',
      'product-sentinela': 'Monitoring',
      'example-table': 'Example of data in table format:',
      'example-file': 'Example of the file to be provided:',
      'btn-upload-label': 'Select files',
      'btn-cancel-label': 'Cancel',
    },
    'bulk-uploader-validator': {
      title: 'Bulk Creation - CSV File',
      'available-data': 'Parsed Data:',
      field: {
        'farmName': 'Farm',
        'ownerId': 'Owner ID',
        'ownerName': 'Owner Name',
        'lat': 'Lat',
        'lng': 'Lng',
        'carCode': 'Car\'s Code',
        'incraAllotment': 'INCRA Allotment Code',
        'geom': 'Geometry',
        'analitica': 'Analitica',
        'sentinela': 'Sentinela',
        'cropType1': 'Crop Type 1',
        'cropType2': 'Crop Type 2',
      },
      'status-label': 'Status',
      status: {
        VALID: 'Ready To Process',
        INVALID_POINT: 'Missing lat or lng',
        NOT_ONLY_ONE_GEOM: 'Please use only one method for select the farm boundaries',
        NO_OWNER_ID: 'Missing Owner ID',
        NO_FARM_NAME: 'Field geom requires a farm name',
        INVALID_GEOMETRY: 'Field geom is not a valid Polygon in GeoJSON format',
        NO_CROP_TYPE: 'Field crop_type_1 is required for the analyses',
      },
      'validation-stats': '{valid} valid rows. {invalid} invalid rows that will be ignored.',
      'btn-continue-label': 'Upload',
      'btn-cancel-label': 'Cancel',
      'btn-close-label': 'Close',
      'owner-api-response-status': {
        BACKEND_ERROR: 'Error while communicating to the server.',
        SUCCESS: 'Owner created.',
        ERROR: 'Error while creating owner.',
        ALREADY_CREATED: 'Owner already created.',
        NOT_CREATED: 'Error while creating owner.',
      },
      'farm-api-response-status': {
        BACKEND_ERROR: 'Error while communicating to the server.',
        SUCCESS: 'Farm created.',
        ERROR: 'Error while creating farm.',
        ALREADY_CREATED: 'Farm already created.',
        NOT_CREATED: 'Error while creating farm.',
        NOT_FOUND_IN_DATABASE: 'Code not found in database.',
      },
      'analysis-api-response-status': {
        BACKEND_ERROR: 'Error while communicating to the server.',
        SUCCESS: 'Process started for {type} {crop_type}.',
        ERROR: 'Error while processing for {type} {crop_type}.',
        ALREADY_CREATED: 'Processamento previamente cadastrada.',
        NOT_CREATED: 'Error while creating analysis.',
      },
    },
    tabs: {
      'table-label': 'Table',
      'map-label': 'Map',
    },
    "farms-map": {
      "farm-name": "Farm",
      "owner": "Owner",
      "city-state": "City/State",
      "area": "Area",
      "view-more": "View More",
    },
    filters: "Filters",
  },
  "table-pagination": {
    "return-five": "Return five pages",
    "previous-page": "Previous page",
    "go-to-page": "go to page {pageNumber}",
    "go-to-page-number": "Go to page",
    "page-size": "Number of items per page",
    "next-page": "Next page",
    "next-five": "Next five pages",
  },
  "environmental": {
    "car-infractions": {
      "loading": "Loading information",
      "no-infractions-yet": "The analysis has not been requested yet. Click in the below button to request it.",
      "generate": "Request Environmental Analysis",
      "infractions-list": "Infractions list:",
      "explantion-ul-title": "Results:",
      "explantion-li-one": "The farmer planted or opened an area that should not;",
      "explantion-li-two": "The farmer planted in a forbidden area;",
      "explantion-li-three": "A false positive has occurred on the platform..",
      "no-infractions-found": "No infractions found.",
      "download-image": "Image",
      "download-geojson": "Geojson",
      "show-in-map": "Show In Map",
      "hide-in-map": "Hide",
      "map-legend": "Map Legend",
    },
    "car-infractions-modal": {
      "title": "Request Environmental Analysis",
      "years-select": "Select the years:",
      "all-years": "All years",
      "just-one": "Just",
      "confirm": "Confirm",
      "cancel": "Cancel",
    },
    "car-infractions-table": {
      "area": "Area",
      "type": "Infraction",
      "cropLabel": "Crop",
      "cropArea": "Crop Área",
      "cropTypeTranslated": "Crop Type",
    },
    'infractions-type': {
      'APP': 'Permanent Protection Area',
      'LEGAL_RESERVE': 'Legal Reserve',
      'INFRACTION': 'INfraction',
    },
  },
  "result-summary": {
    "customer-name": "Customer",
    "territory-name": "Farm",
    "harvest-season": "Harvest Season",
    "displayed-harvest": "Displayed harvest",
    "crop-type": "Crop Type",
    "area": "Area",
    "area-percentage": "Area Percentage",
    "arable-area": "Arable Area",
  },
  "credit": {
    "score-title": "Operational Scores",
    "score": {
      "general": "General Score",
      "track_record": "Track Record",
      "scale": "Scale",
      "zone": "Yield",
      "cluster": "Cluster",
      "homogeneity": "Homogeneity",
      "balance": "Balance",
      "weather": "Climate",
    },
    "score-not-found": "There is not enough information to generate the scores.",
    "score-not-ready": "Please wait, we are already generating the scores.",
  },
  "crop-update": {
    "text-crop-override": "Redrawing crops: {farm} - {cropType} - {year}",
    "text-back": "Voltar",
    "crop-drawer": {
      "all-years": "Upadte all years",
      "btn-upload-file": "Upload Crop File",
      "btn-update": "Update",
      "btn-show-result": "Show result",
      "btn-hide-result": "Hide result",
      "text-crop-list": "New crops",
      "text-crops": "Crop {index} with {area} ha",
      "text-no-crops": "No crop added. Draw or upload a Feature Collection with the property 'type=CROP'."
    }
  },
  'info-tooltip': {
    ndvi: 'The Normalized Difference Vegetation Index (NDVI) is an indicator of photosynthetically active biomass that ranges from 0 to 1. The higher the NDVI value, the greater the amount of vegetation. For a more accurate interpretation, it is necessary to consider the edaphoclimatic factors, as well as the peculiarities of the region and the season.',
    spi: 'The Standardized Precipitation Index (SPI) measures the deviation from the 20-year historical monthly precipitation. The SPI ranges from -2.5 to +2.5, where values below -1.0 indicate drought and its level of severity. Values between -1 and 1 are considered normal.',
    stages: {
      PLANTED: 'Estimated planting date of the crop',
      DEVELOPMENT: 'Indicative of the vegetative phase of the crop measured by increasing the NDVI',
      MATURATION: 'Estimate of the date of the end of the vegetative phase and beginning of the reproductive phase (flowering).',
      DRYING: 'Estimate of the date of the end of the grain filling phase and the beginning of crop senescence.',
      HARVESTED: 'Estimated harvest date after the complete crop cycle.', 
    },
    'credit-trust': {
      general: 'Average of Operational Scores.',
      balance: 'Expansion or retraction of the crop area in the analyzed crop years.',
      climate: 'History of rainfall and temperatures in the area of the territory compared through the evapotranspiration of the plant, according to the critical moments for the vegetative evolution of the plant.',
      cluster: 'Relevance of the culture analyzed within the region where the territory is located.',
      homogeneity: 'Homogeneity of crop yield between plots and between analyzed crop years.',
      scale: 'Relevance of the crop in relation to the total area of the territory in the analyzed crop years.',
      yield: 'Crop yield in the analyzed crop years compared with crop yield in the region.',
      trackRecord: 'Relevance of the crop in relation to the arable area of the territory in the analyzed crop years.',
    },
    'yield-scores': {
      city: 'Crop yield in the crop year compared to the city.',
      microregion: 'Crop yield in the crop year compared to the state.',
      state: 'Crop yield in the crop year compared to the microregion.',
      country: 'Crop yield in the crop year compared to the country.',
    },
    'version': {
      'pipeline-label': 'Pipeline Version',
      'crop-id-label': 'CropId Version',
      'yieldest-label': 'Yield Version',
      'version-label': 'Versioning'
    },
    'biomas-label': 'MapBiomas Project – Collection 7.1 of the Annual Series of Land Use and Coverage Maps of Brazil, accessed on 04/15/2023 through the link: https://brasil.mapbiomas.org/produtos# -- Our models were trained and validated with several data sources, public and private, including MapBiomas'
  },
});

i18n.mergeNumberFormat("en", {
  "rounded-number": {
    style: "decimal",
    maximumFractionDigits: 0
  }
});

i18n.mergeDateTimeFormat("en", {
  short: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric"
  },
  "datetime-short": {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  }
});

